module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmh"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    staticClass: "nl5"
  }), _c('a', {
    attrs: {
      "href": "#/Text/TNTC_Romans4"
    }
  }, [_vm._v("General preface")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    staticClass: "nl5"
  }), _c('a', {
    attrs: {
      "href": "#/Text/TNTC_Romans5"
    }
  }, [_vm._v("Author’s preface")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    staticClass: "nl5"
  }), _c('a', {
    attrs: {
      "href": "#/Text/TNTC_Romans6"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    staticClass: "nl5"
  }), _c('a', {
    attrs: {
      "href": "#/Text/TNTC_Romans6a"
    }
  }, [_vm._v("Select bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    staticClass: "nl5"
  }), _c('a', {
    attrs: {
      "href": "#/Text/TNTC_Romans7"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TNTC_Romans7#rch1"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "nl2"
  }), _vm._v("The audience of the letter")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TNTC_Romans7#rch2"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Date and provenance")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TNTC_Romans7#rch3"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "nl2"
  }), _vm._v("The integrity of the letter")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TNTC_Romans7#rch4"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "nl2"
  }), _vm._v("The occasion for the letter")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TNTC_Romans7#rch5"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "nl2"
  }), _vm._v("The nature of the letter")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TNTC_Romans7#rch6"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "nl2"
  }), _vm._v("Theological themes in Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch12"
    }
  }, [_c('span', {
    staticClass: "nl5"
  }), _c('span', {
    attrs: {
      "href": "#/Text/TNTC_Romans8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Analysis")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch13"
    }
  }, [_c('span', {
    staticClass: "nl5"
  }), _c('span', {
    attrs: {
      "href": "#/Text/TNTC_Romans9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Commentary")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a126f67","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TNTC_Romans3.vue
// module id = 63
// module chunks = 0